/**
 * @file Frontend adapter for the shared notification registry.
 */

import notificationRegistry from "../../../../shared/registries/notificationRegistry.js";

const {
    EVENT_DEFINITIONS,
    EVENT_DEFINITIONS_BY_ID,
    GROUP_DEFINITIONS,
    NOTIFICATION_CLASSIFICATIONS,
    NOTIFICATION_EMAIL_CTA_TYPES,
    NOTIFICATION_GROUPS,
    NOTIFICATION_ROUTE_TARGETS,
    NOTIFICATION_SETTINGS_SURFACES,
    NOTIFICATION_TARGET_TYPES,
    RECIPIENT_STRATEGIES,
    RETIRED_NOTIFICATION_EVENT_IDS,
    getNotificationCleanupPolicy,
    getNotificationEventDefinition,
    getNotificationEventLabel,
    getNotificationRouteTarget,
    getRequiredNotificationConfigEntries,
    getRequiredTeamNotificationConfigEntries,
    isRetiredNotificationEvent,
} = notificationRegistry;

export {
    EVENT_DEFINITIONS,
    EVENT_DEFINITIONS_BY_ID,
    GROUP_DEFINITIONS,
    NOTIFICATION_CLASSIFICATIONS,
    NOTIFICATION_EMAIL_CTA_TYPES,
    NOTIFICATION_GROUPS,
    NOTIFICATION_ROUTE_TARGETS,
    NOTIFICATION_SETTINGS_SURFACES,
    NOTIFICATION_TARGET_TYPES,
    RECIPIENT_STRATEGIES,
    RETIRED_NOTIFICATION_EVENT_IDS,
    getNotificationCleanupPolicy,
    getNotificationEventDefinition,
    getNotificationEventLabel,
    getNotificationRouteTarget,
    getRequiredNotificationConfigEntries,
    getRequiredTeamNotificationConfigEntries,
    isRetiredNotificationEvent,
};
